export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const GETORDERLIST = 'GETORDERLIST'
export const GETORDERLISTBYHOLD = 'GETORDERLISTBYHOLD'
export const GETORDERLISTBYSTATUS = 'GETORDERLISTBYSTATUS'
export const GETORDERLISTBYCLIENTREF = 'GETORDERLISTBYCLIENTREF'
export const GETORDERBYYID = 'GETORDERBYYID'
export const GETORDERPACKAGELISTBYORDERID = 'GETORDERPACKAGELISTBYORDERID'
export const PATCHORDER = 'PATCHORDER'
export const UPDATEORDER = 'UPDATEORDER'
export const GETNOTESLISTBYORDERID = 'GETNOTESLISTBYORDERID'
export const GETFEEDBACKLISTBYORDERID = 'GETFEEDBACKLISTBYORDERID'
export const ADDORDERPACKAGE = 'ADDORDERPACKAGE'
export const ADDORDER = 'ADDORDER'
export const ADDORDERFIELDDATA = 'ADDORDERFIELDDATA'
export const UPDATEORDERFIELDDATA = 'UPDATEORDERFIELDDATA'
export const GETSECTIONSBYTEMPLATEID = 'GETSECTIONSBYTEMPLATEID'
export const GETSECTIONSDATABYORDERID = 'GETSECTIONSDATABYORDERID'
export const GETOVENDORLIST = 'GETOVENDORLIST'
export const GETVENDORBYYID = 'GETVENDORBYYID'
export const POSTNOTE = 'POSTNOTE'
export const DELETEFEEDBACKBYID = 'DELETEFEEDBACKBYID'
export const ADDFEEDBACK = 'ADDFEEDBACK'
export const GETERRORTYPELIST = 'GETERRORTYPELIST'
export const UPLOADPACKAGE = 'UPLOADPACKAGE'
export const PATCHPACKAGE = 'PATCHPACKAGE'
export const CREATEFINALPACKAGE = 'CREATEFINALPACKAGE'
export const GETFINALPACKAGE = 'GETFINALPACKAGE'
export const PATCHORDERPACKAGE = 'PATCHORDERPACKAGE'
export const GETPACKAGECATEGORIESLIST = 'GETPACKAGECATEGORIESLIST'
export const DELETEPACKAGE = 'DELETEPACKAGE'
export const DASHBOARDREPORT = 'DASHBOARDREPORT'
export const GETCLIENTLIST = 'GETCLIENTLIST'
export const GETPRODUCTLIST = 'GETPRODUCTLIST'
export const GETSTATELIST = 'GETSTATELIST'
export const GETCOUNTYLIST = 'GETCOUNTYLIST'
export const GETVENDORLIST = 'GETVENDORLIST'
export const GETORDERSTATUSLIST = 'GETORDERSTATUSLIST'
export const GETSEARCHORDER = 'GETSEARCHORDER'
export const GETORDERRUNSHEET = 'GETORDERRUNSHEET'
export const SAVEORDERRUNSHEET = 'SAVEORDERRUNSHEET'
export const GETTAXHUBDATA = 'GETTAXHUBDATA'
export const SORTALLORDERPACKAGES = 'SORTALLORDERPACKAGES'
export const GETALLROLES = 'GETALLROLES'
export const GETALLPERMISSIONS = 'GETALLPERMISSIONS'
export const SAVEPERMISSIONS = 'SAVEPERMISSIONS'
export const GETCLIENTPRODUCTFEES = 'GETCLIENTPRODUCTFEES'
export const GETSEARCHUSER = 'GETSEARCHUSER'
export const ADDVENDORTOORDER = 'ADDVENDORTOORDER'
export const ADDUSERSTOORDER = 'ADDUSERSTOORDER'
export const ADDVENDORTOUSERS = 'ADDVENDORTOUSERS'
export const REMOVEUSERFROMORDER = 'REMOVEUSERFROMORDER'
export const GETORDERETASBYYORDERID = 'GETORDERETASBYYORDERID'
export const ADDORDERETA = 'ADDORDERETA'
export const DOWNLOADDTDOC = 'DOWNLOADDTDOC'
export const PATCHORDERSHEET = 'PATCHORDERSHEET'
export const VERIFYOTP = 'VERIFYOTP'
export const GETDOCUMENTREASONS = 'GETDOCUMENTREASONS'
export const GETDOCUMENTSELECTIONS = 'GETDOCUMENTSELECTIONS'
export const ADDDOCUMENTSELECTIONS = 'ADDDOCUMENTSELECTIONS'
export const GETSCRAPPEDRUNSHEETDATA = 'GETSCRAPPEDRUNSHEETDATA'
export const GETRUNSHEETSCRAPPINGSTATUS = 'GETRUNSHEETSCRAPPINGSTATUS'
export const TRIGGERRUNSHEETSCRAPPING = 'TRIGGERRUNSHEETSCRAPPING'
export const GETORDERLISTBYHOLD_V2 = 'GETORDERLISTBYHOLD_V2'
export const GETORDERLISTBYSTATUS_V2 = 'GETORDERLISTBYSTATUS_V2'
export const GETORDERLISTBYCLIENTREF_V2 = 'GETORDERLISTBYCLIENTREF_V2'
export const GETORDERLIST_V2 = 'GETORDERLIST_V2'
export const GETSEARCHORDER_V2 = 'GETSEARCHORDER_V2'
